export enum Environment {
    IOS_APP = 'iOS App',
    ANDROID_APP = 'Android App',
    WECHAT = 'WeChat',
    QQ_APP = 'QQ App',
    MOBILE_Android = 'Mobile Android',
    MOBILE_iOS = 'Mobile iOS',
    MOBILE_BROWSER = 'Mobile Browser',
    DESKTOP_OR_UNKNOWN = 'Desktop or Unknown'
  }